/* global  */ // tUrl等のグローバル変数を宣言する

import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if ($('.js-topOpening')[0]) {
  // クッキー処理
  const cookieArray = []
  if (document.cookie !== '') {
    const tmp = document.cookie.split('; ')
    for (let i = 0; i < tmp.length; i++) {
      const data = tmp[i].split('=')
      cookieArray[data[0]] = decodeURIComponent(data[1])
    }
  }
  const topOpening = cookieArray['topOpening']
  if (!topOpening) {
    $('.js-topOpening').addClass('play')
    document.cookie = 'topOpening=allready;max-age=' + 60 * 60 * 24 * 365 + ';path=/'
  }
}

$('.js-topJobsItem').on({
  mouseover: function () {
    // const idx = $('.js-topJobsItem').index($(this)) + 1
    const idx = $(this).attr('data-jobIdx')
    $('.js-topJobsItem-list').addClass('topJobs__list--' + idx)
  },
  mouseout: function () {
    const idx = $(this).attr('data-jobIdx')
    $('.js-topJobsItem-list').removeClass('topJobs__list--' + idx)
  },
})

$('.js-topTalk-more').on('mouseover', function () {
  $('.js-topTalk-img').addClass('hover')
})
$('.js-topTalk-more').on('mouseleave', function () {
  $('.js-topTalk-img').removeClass('hover')
})

if ($('.js-acc')[0]) {
  $('.js-acc').next().hide()
}
$('.js-acc').on('click', function () {
  $(this).toggleClass('open')
  $(this).next().slideToggle()
})

/*
   ######  ##       #### ########  ########
  ##       ##        ##  ##     ## ##
   ######  ##        ##  ##     ## ######
        ## ##        ##  ##     ## ##
   ######  ######## #### ########  ########
*/
if ($('.js-topMv')[0]) {
  let maxSlideNum = 0
  let thisSlideIndex = 0
  const topMvSlide = new Swiper('.js-topMv', {
    autoplay: {
      delay: 5000,
    },
    loop: true,
    effect: 'fade',
    pagination: {
      el: '.js-topMv-pagination',
      type: 'bullets',
      clickable: true,
    },
    on: {
      init: function () {
        let slideNum = []
        /*
          下記の繰り返しで swiper-slide の data属性に付与されている swiper-slide-index を取得して
          配列に格納していく、 Math.maxで配列の中に格納されている数値の中で一番数が大きいものを maxSlideNum に入れる
        */
        let slideLength = $('.js-topMv .swiper-slide').length
        if (this.loopedSlides) {
          for (let i = 0; i < slideLength; i++) {
            slideNum.push($('.js-topMv .swiper-slide')[i].dataset.swiperSlideIndex)
            maxSlideNum = Math.max(...slideNum) + 1
          }
        } else {
          maxSlideNum = slideLength
        }
        // 出力
        $('.js-topMv-pagination-num .max').text(maxSlideNum)
        $('.js-topMv-pagination-num .current').text('1')
      },
      transitionStart: function () {
        // スライドが切り替わった時
        thisSlideIndex =
          $('.js-topMv-pagination .swiper-pagination-bullet').index(
            $('.js-topMv-pagination .swiper-pagination-bullet-active')
          ) + 1
        $('.js-topMv-pagination-num .current').text(thisSlideIndex)
      },
    },
  })
}

let topPeopleSlide
if (document.getElementsByClassName('js-topPeople')[0]) {
  // SP時だけスライダーにする
  let topPeopleSlideActive = false
  if (window.matchMedia('(max-width:768px)').matches) {
    topPeopleSlideInit()
    topPeopleSlideActive = true
  }
  window.addEventListener('resize', function (e) {
    if (topPeopleSlideActive && window.matchMedia('(min-width:769px)').matches) {
      topPeopleSlide.destroy()
      topPeopleSlideActive = false
    } else if (!topPeopleSlideActive && window.matchMedia('(max-width:768px)').matches) {
      topPeopleSlideInit()
      topPeopleSlideActive = true
    }
  })
}
function topPeopleSlideInit() {
  topPeopleSlide = new Swiper('.js-topPeople', {
    loop: true,
    pagination: {
      el: '.js-topPeople-pagination',
      type: 'bullets',
    },
    navigation: {
      nextEl: '.js-topPeople-next',
      prevEl: '.js-topPeople-prev',
    },
  })
}

let interviewPageOtherSlide
if (document.getElementsByClassName('js-interviewPageOther')[0]) {
  // SP時だけスライダーにする
  let interviewPageOtherSlideActive = false
  if (window.matchMedia('(max-width:768px)').matches) {
    topPeopleSlideInit()
    interviewPageOtherSlideActive = true
  }
  window.addEventListener('resize', function (e) {
    if (interviewPageOtherSlideActive && window.matchMedia('(min-width:769px)').matches) {
      interviewPageOtherSlide.destroy()
      interviewPageOtherSlideActive = false
    } else if (!interviewPageOtherSlideActive && window.matchMedia('(max-width:768px)').matches) {
      interviewPageOtherSlideInit()
      interviewPageOtherSlideActive = true
    }
  })
}
function interviewPageOtherSlideInit() {
  interviewPageOtherSlide = new Swiper('.js-interviewPageOther', {
    loop: true,
    pagination: {
      el: '.js-interviewPageOther-pagination',
      type: 'bullets',
    },
    navigation: {
      nextEl: '.js-interviewPageOther-next',
      prevEl: '.js-interviewPageOther-prev',
    },
  })
}

let jobSecIntervewSlide
if (document.getElementsByClassName('js-jobSecIntervew')[0]) {
  const swiperEl = '.js-jobSecIntervew'
  jobSecIntervewSlideSet(swiperEl)
}
if (document.getElementsByClassName('js-jobSecIntervew-02')[0]) {
  const swiperEl = '.js-jobSecIntervew-02'
  jobSecIntervewSlideSet02(swiperEl)
}
if (document.getElementsByClassName('js-jobSecIntervew-03')[0]) {
  const swiperEl = '.js-jobSecIntervew-03'
  jobSecIntervewSlideSet03(swiperEl)
}
function jobSecIntervewSlideSet(swiperEl) {
  // SP時だけスライダーにする
  let jobSecIntervewSlideActive = false
  if (window.matchMedia('(max-width:768px)').matches) {
    jobSecIntervewSlideInit(swiperEl)
    jobSecIntervewSlideActive = true
  }
  window.addEventListener('resize', function (e) {
    if (jobSecIntervewSlideActive && window.matchMedia('(min-width:769px)').matches) {
      jobSecIntervewSlide.destroy()
      jobSecIntervewSlideActive = false
    } else if (!jobSecIntervewSlideActive && window.matchMedia('(max-width:768px)').matches) {
      jobSecIntervewSlideInit(swiperEl)
      jobSecIntervewSlideActive = true
    }
  })
}
function jobSecIntervewSlideInit(el) {
  jobSecIntervewSlide = new Swiper(el, {
    loop: true,
    pagination: {
      el: '.js-jobSecIntervew-pagination',
      type: 'bullets',
    },
    navigation: {
      nextEl: '.js-jobSecIntervew-next',
      prevEl: '.js-jobSecIntervew-prev',
    },
  })
}
function jobSecIntervewSlideSet02(swiperEl) {
  // SP時だけスライダーにする
  let jobSecIntervewSlideActive = false
  if (window.matchMedia('(max-width:768px)').matches) {
    jobSecIntervewSlideInit02(swiperEl)
    jobSecIntervewSlideActive = true
  }
  window.addEventListener('resize', function (e) {
    if (jobSecIntervewSlideActive && window.matchMedia('(min-width:769px)').matches) {
      jobSecIntervewSlide.destroy()
      jobSecIntervewSlideActive = false
    } else if (!jobSecIntervewSlideActive && window.matchMedia('(max-width:768px)').matches) {
      jobSecIntervewSlideInit02(swiperEl)
      jobSecIntervewSlideActive = true
    }
  })
}
function jobSecIntervewSlideInit02(el) {
  jobSecIntervewSlide = new Swiper(el, {
    loop: true,
    pagination: {
      el: '.js-jobSecIntervew-pagination-02',
      type: 'bullets',
    },
    navigation: {
      nextEl: '.js-jobSecIntervew-next-02',
      prevEl: '.js-jobSecIntervew-prev-02',
    },
  })
}
function jobSecIntervewSlideSet03(swiperEl) {
  // SP時だけスライダーにする
  let jobSecIntervewSlideActive = false
  if (window.matchMedia('(max-width:768px)').matches) {
    jobSecIntervewSlideInit03(swiperEl)
    jobSecIntervewSlideActive = true
  }
  window.addEventListener('resize', function (e) {
    if (jobSecIntervewSlideActive && window.matchMedia('(min-width:769px)').matches) {
      jobSecIntervewSlide.destroy()
      jobSecIntervewSlideActive = false
    } else if (!jobSecIntervewSlideActive && window.matchMedia('(max-width:768px)').matches) {
      jobSecIntervewSlideInit03(swiperEl)
      jobSecIntervewSlideActive = true
    }
  })
}
function jobSecIntervewSlideInit03(el) {
  jobSecIntervewSlide = new Swiper(el, {
    loop: true,
    pagination: {
      el: '.js-jobSecIntervew-pagination-03',
      type: 'bullets',
    },
    navigation: {
      nextEl: '.js-jobSecIntervew-next-03',
      prevEl: '.js-jobSecIntervew-prev-03',
    },
  })
}

/*
##    ##    ###    ##     ##
####  ##  ##   ##  ##     ##
## ## ## ##     ## ##     ##
##  #### #########  ##   ##
##    ## ##     ##    ###
*/
$(window).on('load', function () {
  if ($('.js-stickyNav')[0]) {
    const windowHeight = $(window).height()
    const headerHeight = 90
    const stickeyNavHeight = $('.js-stickyNav').height()
    const stickeyTargetHeight = $('.js-stickyNav-target').height()
    const stickeyTargetTop = $('.js-stickyNav-target').offset().top - headerHeight * 2
    const stickeyTargetBottom = stickeyTargetTop + stickeyTargetHeight - stickeyNavHeight
    let distance = 0
    if (window.matchMedia('(min-width:769px)').matches) {
      distance = $(this).scrollTop()
      if (distance <= stickeyTargetTop) {
        $('.js-stickyNav').removeClass('fixed')
        $('.js-stickyNav').removeClass('bottom')
      } else if (distance >= stickeyTargetBottom) {
        $('.js-stickyNav').removeClass('fixed')
        $('.js-stickyNav').addClass('bottom')
      } else {
        $('.js-stickyNav').removeClass('bottom')
        $('.js-stickyNav').addClass('fixed')
      }
      $(document).on('scroll', function () {
        distance = $(this).scrollTop()
        if (distance <= stickeyTargetTop) {
          $('.js-stickyNav').removeClass('fixed')
          $('.js-stickyNav').removeClass('bottom')
        } else if (distance >= stickeyTargetBottom) {
          $('.js-stickyNav').removeClass('fixed')
          $('.js-stickyNav').addClass('bottom')
        } else {
          $('.js-stickyNav').removeClass('bottom')
          $('.js-stickyNav').addClass('fixed')
        }
      })
    }
  }
  if ($('.js-currentNav')[0]) {
    const headerHeight = 90
    let distance = 0
    let topPos = 0
    let target = $('.js-currentNav-item').eq(0)

    const navItem = $('.js-currentNav')
    if (window.matchMedia('(min-width:769px)').matches) {
      $(document).on('scroll', function () {
        distance = $(this).scrollTop()
        navItem.each(function (index) {
          topPos = $(this).offset().top - headerHeight * 2
          if (topPos <= distance) {
            target = $('.js-currentNav-item').eq(index)
            target.siblings().children().removeClass('current')
            target.children().addClass('current')
          }
        })
      })
    }
  }
})

$('.js-interviewFilter').on('change', function () {
  const url = $(this).val()
  if (url !== '') {
    window.location.href = url
  }
})

/*
#### ##    ## ########          #######  ########   ######
 ##  ####  ##    ##            ##     ## ##     ## ##
 ##  ## ## ##    ##    ####### ##     ## ########   ######
 ##  ##  ####    ##            ##     ## ##     ##       ##
#### ##    ##    ##             #######  ########   ######
*/
$(function () {
  if (document.getElementsByClassName('js-in')[0]) {
    // 画面に入った監視対象に.animatedを付加
    // Intersection Observer
    intObs()
  }
  function intObs() {
    let rootMargin = '-10px 0px'
    if (window.matchMedia('(max-width:768px)').matches) {
      //SPは検出を早くする
      rootMargin = '100px 0px'
    }
    const intObsOption = {
      // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
      rootMargin: rootMargin, // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
      threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
    }
    const observer = new IntersectionObserver(intObsCallback, intObsOption)
    const intObsItems = document.getElementsByClassName('js-in')
    for (let index = 0; index < intObsItems.length; index++) {
      const intObsItem = intObsItems[index]
      observer.observe(intObsItem) // 監視対象に加える
    }
    function intObsCallback(entries) {
      for (let index = 0; index < entries.length; index++) {
        const entry = entries[index]
        if (entry.isIntersecting) {
          const entryItem = entry.target
          entryItem.classList.add('active')
          observer.unobserve(entryItem) // 監視対象から外す
        }
      }
    }
  }
})
